import { Text } from 'grommet'
import styled from 'styled-components'

export default styled(Text)`
    font-size: 22px;
    margin-top: 10px;
    margin-bottom: 10px;
`
